import algoliasearch from "algoliasearch/lite";
import { default as React, useState, useMemo, useEffect } from "react";
import { navigate } from "gatsby";
import { InstantSearch, } from "react-instantsearch-hooks-web";
import qs from 'qs';
// import { MenuSelect } from "../search/menuSelect";
import { Button, Grid } from "@mui/material";
// import RangeSlider from "../search/rangeSlider";
import SearchIcon from '@mui/icons-material/Search';
import { SearchBox } from "../search/SearchBox";
import { MenuSelect } from "../search/MenuSelect";

const createURL = state => `listings?${qs.stringify(state)}`;
const searchStateToUrl = searchState =>
  searchState ? createURL(searchState) : '';

const urlToSearchState = ({ search }) => qs.parse(search.slice(1));

function SearchWidget({ location }) {
  const [searchState, setSearchState] = useState(urlToSearchState(location));

  function onSearchStateChange(updatedSearchState) {
    setSearchState(updatedSearchState);
  }

  useEffect(() => {
    setSearchState(urlToSearchState(location));
  }, [location]);

  const navigateSearch = () => {
    navigate(searchStateToUrl(searchState))
  }

  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
      ),
    []
  );

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      navigateSearch(searchStateToUrl(searchState));
    }
  }

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={"listings"}
      initialUiState={searchState}
      onStateChange={onSearchStateChange}
    >
      <div className="">
        <div className="pr-4 py-4 md:grid grid-cols-2 items-center sm:-mr-28">
          <div className="lg:w-full xl:border-r sm:mb-0 mb-4 border-gray-300 text-center lg:mr-96">
            <SearchBox onKeyPress={handleKeyDown} />
          </div>
          <div className="w-full">
            <button className="border text-lg rounded-r-md f-m-m sm:px-8 px-20 xl:py-5 lg:py-4 py-3 xl:leading-4 hover:bg-blue-800 border-blue-600 hover:border-blue-800 text-gray-50 bg-blue-600 focus:outline-none" onClick={navigateSearch}>
              Search
            </button>
          </div>
        </div>
      </div>

    </InstantSearch>
  );
}

export default SearchWidget;